import { render } from "./CursoDetalle.vue?vue&type=template&id=2bc4aec0&scoped=true"
import script from "./CursoDetalle.vue?vue&type=script&lang=js"
export * from "./CursoDetalle.vue?vue&type=script&lang=js"

import "./CursoDetalle.vue?vue&type=style&index=0&id=2bc4aec0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc4aec0"]])

export default __exports__